import {useTranslation} from '@aboutyou/i18n';
import {useCountdown} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';

export const UrgencyLabelLessThan12Hours: FC<{couponExpiryDate: Date}> = ({
  couponExpiryDate,
}) => {
  const {t} = useTranslation();
  const [_, hours, minutes] = useCountdown(couponExpiryDate);

  return (
    <Wrapper>
      <span>⏰</span>
      {hours === '00'
        ? t('ONLY {minutes}M - HURRY UP!', {
            minutes,
          })
        : t('ONLY {hours}H {minutes}M - HURRY UP!', {
            hours,
            minutes,
          })}
    </Wrapper>
  );
};

export const UrgencyLabelLessThan5Days: FC<{couponExpiryDate: Date}> = ({
  couponExpiryDate,
}) => {
  const {t} = useTranslation();
  const date = couponExpiryDate
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    })
    .replace(/\//g, '.');

  return (
    <Wrapper>
      <span>⏰</span>
      {t('Valid Until {date}', {
        date,
      })}
    </Wrapper>
  );
};

const Wrapper = styled.span`
  display: flex;
  gap: 4px;
  text-transform: uppercase;
`;
